import { panelThemeClasses } from "../../theme/themeClasses";

/**
 * @deprecated Use the semantic Tailwind tokens directly (bg-surface, bg-card, text-content, border-line…).
 *
 * El argumento se acepta y se ignora: las secciones portadas de CC-CONSOLE aún
 * llaman `buildThemeClasses(isDarkMode)`; aquí el tema sale de los tokens.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const buildThemeClasses = (_isDarkMode?: boolean) => panelThemeClasses();
